import React from 'react';
import { identifyComponent } from '../../../util';
import { TableBodyRow } from '../TableBodyRow';
import { useBodyRows } from '../useBodyRows';
import { TableBodyBase } from './Base';
import { TableBodyProps } from './types';

export function TableBody<R>({
  columns,
  rows,
  rowKeyAccessor,
  rowComponent = TableBodyRow,
  rowProps = {},
}: TableBodyProps<R>) {
  const renderedRows = useBodyRows(rowComponent, columns, rows, rowKeyAccessor, rowProps);
  return (
    <TableBodyBase data-component="TableBody" {...identifyComponent('table-body')}>
      {renderedRows}
    </TableBodyBase>
  );
}
